module.exports = __webpack_public_path__ + "static/media/bg-4.cfbfb1c7.jpg";